import React, { useEffect, useRef, useState } from "react";

function HomeBox2() {
    const sectionRef = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.4 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => observer.disconnect();
    }, []);

    return (
        <div className={`homebox2main ${visible ? "homebox2-visible" : ""}`} ref={sectionRef}>
            <div className='container'>
                <div className='homebox2'>
                    <div className='homebox2-left'>
                        <img src="/image 13.png" alt="hero-img" />
                    </div>
                    <div className='homebox2-right'>
                        <span>Boost Engagement</span>
                        <h2>Keep your most valuable customers engaged</h2>
                        <p>Keep your regular customers coming back and stay present between visits. Every stamp or reward refreshes their wallet card, so your business stays top of mind.</p>
                        <h2>Data that drives results.</h2>
                        <p>Capture customer details at sign-up to understand your most loyal customers and their visit habits. Monitor cards, stamps, and rewards in real time to fine-tune offers and increase customer return rates.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomeBox2